var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNearIcon = function SvgNearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.842 3.22v9.263l4.737-3.54.474.416-3.973 5.595C2.605 16.308 0 15.392 0 13.519V2.08C0 .144 2.757-.739 4.18.743l10.978 11.433V3.292l-4.263 3.16-.474-.416L13.8.813C15.21-.696 18 .178 18 2.13v11.184c0 1.937-2.757 2.82-4.18 1.338L2.842 3.219Z",
    clipRule: "evenodd"
  })));
};
export default SvgNearIcon;